var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.953613H513V342.954H0V0.953613Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9 171.653L0 315.553V27.7534L215.9 171.653ZM513 27.7534V315.553L297.1 171.653L513 27.7534Z",
    fill: "#47A644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 27.7536L296.1 171.654L512 315.554V342.254H471.9L256 198.354L40.1 342.254H0V315.554L215.9 171.654L0 27.7536V0.953613H40.1L256 144.854L471.9 0.953613H512V27.7536Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 27.7536L297.1 171.654L513 315.554V342.954H473L256 198.354L39 342.954H0V315.554L215.9 171.654L0 27.7536V0.953613H40.1L256 144.854L471.9 0.953613H513V27.7536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6 271.854C306.939 271.854 351.8 226.993 351.8 171.654C351.8 116.315 306.939 71.4536 251.6 71.4536C196.261 71.4536 151.4 116.315 151.4 171.654C151.4 226.993 196.261 271.854 251.6 271.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4 104.554L258.8 117.454H273.6L266.2 130.254L273.6 143.054H258.8L251.4 155.954L244 143.054H229.2L236.6 130.254L229.2 117.454H244L251.4 104.554ZM290.2 171.254L297.6 184.154H312.4L305 196.954L312.4 209.754H297.6L290.2 222.654L282.8 209.754H267.9L275.3 196.954L267.9 184.154H282.8L290.2 171.254ZM213 171.254L220.4 184.154H235.3L227.9 196.954L235.3 209.754H220.4L213 222.654L205.6 209.754H190.8L198.2 196.954L190.8 184.154H205.6L213 171.254Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.4 101.539L259.669 115.954H276.2L267.933 130.254L276.2 144.554H259.669L251.4 158.968L243.131 144.554H226.6L234.867 130.254L226.6 115.954H243.131L251.4 101.539ZM251.4 107.568L244.869 118.954H231.8L238.333 130.254L231.8 141.554H244.869L251.4 152.939L257.931 141.554H271L264.467 130.254L271 118.954H257.931L251.4 107.568ZM213 168.239L221.269 182.654H237.9L229.633 196.954L237.9 211.254H221.269L213 225.668L204.731 211.254H188.2L196.467 196.954L188.2 182.654H204.731L213 168.239ZM290.2 168.239L298.469 182.654H315L306.733 196.954L315 211.254H298.469L290.2 225.668L281.931 211.254H265.3L273.567 196.954L265.3 182.654H281.931L290.2 168.239ZM290.2 174.268L283.669 185.654H270.5L277.033 196.954L270.5 208.254H283.669L290.2 219.639L296.731 208.254H309.8L303.267 196.954L309.8 185.654H296.731L290.2 174.268ZM213 174.268L206.469 185.654H193.4L199.933 196.954L193.4 208.254H206.469L213 219.639L219.531 208.254H232.7L226.167 196.954L232.7 185.654H219.531L213 174.268Z",
    fill: "#47A644"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.953613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.191de535dd7fac0d2ec2d57c9a0db281.svg";
export { ForwardRef as ReactComponent };